import { useFeatureFlags } from '@brightdrop/feature-flags-client';

/** LaunchDarkly flag key for Sidekick legal-consent API integration. */
export const SIDEKICK_LEGAL_CONSENT_API_FLAG = 'SDPCDXP-1838-SIDEKICK-LEGAL';

/**
 * Resolves whether Sidekick should use the legal-consent API.
 *
 * Only the boolean literal `true` enables the API path. Missing and
 * non-boolean values preserve the package's localStorage fallback.
 *
 * @returns Whether legal consent should use the Sidekick API.
 */
export const useIsSidekickLegalConsentApiEnabled = (): boolean => {
  const { getFlag } = useFeatureFlags();
  return getFlag(SIDEKICK_LEGAL_CONSENT_API_FLAG) === true;
};
